import { Component } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
@Component({
    selector: 'app-scan',
    templateUrl: './scan.component.html',
    styleUrls: ['./scan.component.scss'],
    standalone: false
})
export class ScanComponent {

}
